import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CsrfTokenService {
  constructor(private http: HttpClient) {}

  getCsrfToken(): Observable<any> {
    return this.http.get('/api/csrf/token');
  }
}
